import axios from "axios";
import { FETCH_ALL_USER_API } from "../Constants/Apis";

export const getUsers = async () => {
  try {
    return axios.get(FETCH_ALL_USER_API);
  } catch (e) {
    return console.log(e);
  }
};

export const fetchUserById = async (id) => {
  try {
    return axios.get(`${FETCH_ALL_USER_API}/detail/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

export const updateUserById = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_USER_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const changePassword = async (id, { oldPassword, newPassword }) => {
  try {
    return axios.put(`${FETCH_ALL_USER_API}/change-password/${id}`, {
      oldPassword,
      newPassword
    });
  } catch (e) {
    return console.log(e);
  }
};

export const createUser = async (userData) => {
  try {
    return axios.post(FETCH_ALL_USER_API, userData);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteUser = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_USER_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};
